import { useContext, useState } from "react";
import { cleanObject } from "../../../../../helpers";
import { ToastContext } from "../../../../../hooks/context";
import { useCreateTerminalBusinessAccount } from "../../../../../hooks/api/mutations/useTerminals";
import { useNavigate } from "react-router-dom";
import { useGetOpayMerchantIndustries } from "../../../../../hooks/api/queries/useTerminals";

export const useConnectBusiness = ({
  businessAccountDetails = {},
  terminalType = "",
  fieldProps,
  setStep = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const [formDetails, setFormDetails] = useState({
    api_key: businessAccountDetails?.api_key || "",
    merchant_code: businessAccountDetails?.merchant_code || "",
    merchant_name: businessAccountDetails?.merchant_name || "",
    webhook_secret: businessAccountDetails?.webhook_secret || "",
    client_auth_key: businessAccountDetails?.client_auth_key || "",
    opay_public_key: businessAccountDetails?.opay_public_key || "",
    merchant_industry: businessAccountDetails?.merchant_industry || "",
  });
  const navigate = useNavigate();
  const removeFields = fieldProps?.removeFields || [];

  const { data: opayIndutries, isLoading: isLoadingIndustries } =
    useGetOpayMerchantIndustries({
      isEnabled: terminalType === "OPAY" ? true : false,
    });

  const { mutate: connectBusinessMutate, isLoading: isConnectingBusiness } =
    useCreateTerminalBusinessAccount({
      path: fieldProps?.postEndpoint,
      queryKey: fieldProps?.getQueryKey,
    });

  const connectBusiness = () => {
    const data = getSubmissionData();
    connectBusinessMutate(data, {
      onSuccess: () => {
        triggerToast("Account connection successful", "success");
        //   if (isUpdateBusinessOnly)
        //     return navigate(
        //       pathConstants.APPS_INTEGRATION_TERMINALS +
        //         `?terminal_type=${terminalType}&show_webhook_url=true`,
        //     );

        const path = fieldProps.route(terminalType);
        if (path) return navigate(path);

        setStep((prev) => prev + 1);
      },
    });
  };

  const getSubmissionData = () => {
    const data = {
      api_key: formDetails?.api_key,
      merchant_code: formDetails?.merchant_code,
      merchant_name: formDetails?.merchant_name,
      webhook_secret: formDetails?.webhook_secret,
      opay_public_key: formDetails?.opay_public_key,
      client_auth_key: formDetails?.client_auth_key,
      merchant_industry: formDetails?.merchant_industry,
    };

    // Keep the stored secret when the merchant did not edit the masked
    // value returned by the backend.
    ["api_key", "webhook_secret"].forEach((key) => {
      if (data[key] === businessAccountDetails?.[key]) delete data[key];
    });

    return cleanObject(data, [...removeFields]);
  };

  return {
    isConnectingBusiness,
    isLoadingIndustries,
    formDetails,
    opayIndutries,
    setFormDetails,
    connectBusiness,
    triggerToast,
  };
};
